import { get, del } from '../..';
import { buildUrl } from '../../../utils';

export const getClassicSSOConfig = (customerId: string) =>
  get(buildUrl(`/v1/qwfmbackoffice/saml/${customerId}`));

export const deleteClassicSSOConfig = (customerId: string) =>
  del(buildUrl('/v1/qwfmbackoffice/saml'), {
    customerIds: [customerId],
  });
